// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
} from "../../../../components";
import "./index.scss";
import values from "../../../../values";
import Context from "../../../../context";
import { IItem } from "../../../../types/common.interface";
import { useQuery } from "react-query";
import api from "../../../../api";
import { ICreateAndUpdateMunicipality } from "../../../../types/municipality.interface";
import { ICreateAndUpdateCompany } from "../../../../types/company.interface";
import utils from "../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";

const Filter = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestDriver, setRequestDriver } = useContext(Context.DriverScreen);
  const userType = utils.stringHexConversion?.reverse(
    Cookies.get(constants?.USER?.TYPE)
  );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const allMunicipalities = useQuery(
    [values.useQueryKeys.getAllMunicipality],
    () => api.postMethod.administrator.getAllMunicipality({})
  );
  const allCompanies = useQuery([values.useQueryKeys.getAllCompany], () =>
    api.postMethod.administrator.getAllCompany({})
  );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        {userType === "ADMIN" && (
          <>
            <p className="filter-labels">شهرداری:</p>
            <CustomDropdownSearch
              items={allMunicipalities?.data?.result}
              itemName="name"
              defaultItem={requestDriver?.filters?.municipality}
              onSelectItem={(event: ICreateAndUpdateMunicipality) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,
                    municipality: event,
                  },
                })
              }
              placeHolder="انتخاب شهرداری"
              isLoading={allMunicipalities.isLoading}
            />
          </>
        )}
        {userType !== "COMPANY" && (
          <>
            <p className="filter-labels">شرکت:</p>
            <CustomDropdownSearch
              items={allCompanies?.data?.result}
              itemName="name"
              defaultItem={requestDriver?.filters?.company}
              onSelectItem={(event: ICreateAndUpdateCompany) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,
                    company: event,
                  },
                })
              }
              placeHolder="انتخاب شرکت"
              isLoading={allCompanies.isLoading}
            />
          </>
        )}
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestDriver!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};
export default Filter;
